import { AuthorizationService } from '@services/auth';
import {
  searchProductsTool,
  getCartTool,
  addToCartTool,
  removeFromCartTool,
  changeCartItemQuantityTool,
  navigateToPageTool,
  getOrderHistoryTool,
  getProductDetailsTool
} from './tools';
import { Cart } from '@services/cart';
import { NextRouter } from 'next/router';
import '@mcp-b/global';

/**
 * This service is used to create a Web Model Context,
 * and provide it to browser using W3C Web Model Context API (@mcp-b/global)
 */
export class McpService extends AuthorizationService {
  static readonly serviceName: string = 'McpService';
  private onCartChange: (cart: Cart | null) => void;
  private router: NextRouter;

  constructor() {
    super();
  }

  public async provideTools(): Promise<void> {
    if (!('modelContext' in navigator)) return;
    const tools = [ searchProductsTool,
      getCartTool,
      addToCartTool,
      removeFromCartTool,
      changeCartItemQuantityTool,
      navigateToPageTool,
      getOrderHistoryTool,
      getProductDetailsTool ];

    navigator.modelContext.provideContext({ tools });
  }

  public triggerCartUpdate(cart: Cart | null): void {
    if (this.onCartChange) this.onCartChange(cart);
  }

  public navigateToPage(page: string): void {
    if (this.router) this.router.push(page);
  }
}
